import { Box, Grid, useTheme } from "@mui/material";

import Form from "./Form";

export default function Hero() {
  const theme = useTheme();
  return (
    <Grid container spacing={0}>
      <Grid size={{ xs: 12, md: 7 }}>
        <Box
          component="video"
          src="/hero.mp4"
          autoPlay
          muted
          playsInline
          onEnded={(e) => e.currentTarget.pause()}
          sx={{
            width: "100%",
            minHeight: "100%",
            objectFit: "cover",
          }}
        />
      </Grid>
      <Grid size={{ xs: 12, md: 5 }}>
        <Box
          sx={{
            backgroundColor: theme.palette.background.default,
            minHeight: "100%",
            p: 5,
            pb: 12,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Form />
        </Box>
      </Grid>
    </Grid>
  );
}
